import {
  SET_BVN_LOADING,
	SET_BVN_PENDING_USERS,
	SET_BVN_UNVERIFIED_USERS,
	SET_BVN_VERIFIED_USERS,
} from '../actions/constants';
import { pending, unverified, verified } from '../constants/query';

const defaultState = {
	[unverified]: [],
	[verified]: [],
	[pending]: [],
  BVN_LOADING: false,
};

export default (state = defaultState, action) => {
	switch (action.type) {
		case SET_BVN_UNVERIFIED_USERS:
			return { ...state, [unverified]: action.payload, BVN_LOADING: false };
		case SET_BVN_VERIFIED_USERS:
			return { ...state, [verified]: action.payload, BVN_LOADING: false };
		case SET_BVN_PENDING_USERS:
			return { ...state, [pending]: action.payload, BVN_LOADING: false };
		case SET_BVN_LOADING:
			return { ...state, BVN_LOADING: !state.BVN_LOADING };
		default:
			return state;
	}
};
